import { render, staticRenderFns } from "./staff-admin.view.vue?vue&type=template&id=063b2e98&scoped=true&"
import script from "./staff-admin.view.ts?vue&type=script&lang=ts&"
export * from "./staff-admin.view.ts?vue&type=script&lang=ts&"
import style0 from "./staff-admin.view.scss?vue&type=style&index=0&id=063b2e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063b2e98",
  null
  
)

export default component.exports